import ConsoleList from "../page_elements/ConsoleList";
import Typography from '@mui/material/Typography';
import Topbar from '../page_elements/Topbar';


export function HomePage(){
  return <>
    <Topbar/>
    <Typography
      variant="h3"
      component="div"
      sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' }, textAlign:"center", color:"white" }}  
    >
      Bienvenue sur le site dont tu ne dois pas partager l'existance. 
    </Typography>
    <ConsoleList handleConsoleChange={null} />;
  </>
}
